const CLOUDFRONT_LANDING_PAGE_ROOT_URL = 'https://d2rwz7a7lb9mw2.cloudfront.net/landingpage';

const unique_1_monthly_plan_banner = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/monthly_plan_banner_1.png`;
const unique_1_yearly_plan_banner = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/yearly_plan_banner.png`;
const unique_1_quarterly_plan_banner = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/quarterly_plan_banner.png`;

const unique_variation_2_banner_1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/unique_variariation_2_banner1_3.png`;
const unique_variation_2_banner_2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/unique_variariation_2_banner2.png`;
const unique_variation_2_banner_3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/unique_variariation_2_banner3.png`;

const unique_variation_1_main_banner = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/video_banner_unique_screen.png`;

export const Images = {
  unique_1_monthly_plan_banner,
  unique_1_yearly_plan_banner,
  unique_1_quarterly_plan_banner,

  unique_variation_2_banner_1,
  unique_variation_2_banner_2,
  unique_variation_2_banner_3,

  unique_variation_1_main_banner,
};
